import React from 'react';
import { PolaGroupSection } from '../components/PolaGroupSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-781">
      <PolaGroupSection data-id="element-782" />
      <SolutionsSection data-id="element-783" />
    </div>;
}